export default __webpack_public_path__ + "static/media/begambleawareorg.d742ca3e.webp";